import React from "react";
import { usePageHardwareHook } from "./hardware-hooks";

type PageContextHardware = ReturnType<typeof usePageHardwareHook>;
export const HardwareContext = React.createContext<PageContextHardware | null>(
  null,
);

export function usePageContextHardware() {
  const context = React.useContext(HardwareContext);

  if (!context) {
    throw new Error(
      "usePageContextHardware must be used within a PageContextHardwareProvider",
    );
  }

  return context;
}
